var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submit_main_wrap"},[_c('div',{staticClass:"submit_wrap item_create_btn"},[_c('div',{staticClass:"submit_btn"},[_c('button',{staticClass:"enroll_submit_btn",on:{"click":function($event){return _vm.save('nosale')}}},[_vm._v(_vm._s(_vm.$t('save')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }